// extracted by mini-css-extract-plugin
module.exports = {"container":"RowRecordStyles_container__tDnl_","value":"RowRecordStyles_value__2jWJp","name":"RowRecordStyles_name__1O5CX"};